// React
import React, { useState } from 'react';

// Fontowesome Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faDesktop, faMobileAlt, faTrash, faPlus, faUpload, } from '@fortawesome/free-solid-svg-icons';

// Images
import Postimage from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/post.svg';
import Storyimage from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/story.svg';
import Storycarouselimage from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/story-carousel.svg';
import Postcarouselimage from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/post-carousel.svg';
import UploadLogoIcon from '../../../assets/SocialMediaMockupGeneratorToolAssets/images/upload-logo-icon.svg';

// Components
import FacebookPreview from '../PostPreviews/FacebookPreview';

const SocialMediaPostCreator = () => {
    const [formData, setFormData] = useState({
        postType: 'Post',
        imagePreview: null,
        imageFile: null,
        pageInfo: '',
        message: '',
        cards: [
            {
                id: Date.now(),
                title: '',
                description: '',
                image: null,
                isDefault: true,
                callToAction: 'Learn more',
                displayLink: '',
                headline: '',
                urlLandingPage: '',
            },
        ],
    });
    const [activeTab, setActiveTab] = useState('organic');
    const [activeDevice, setActiveDevice] = useState('desktop');
    // Card
    const handleCardChange = (id, field, value) => {
        setFormData((prevState) => ({
            ...prevState,
            cards: prevState.cards.map((card) =>
                card.id === id ? { ...card, [field]: value } : card
            ),
        }));
    };
    const addNewCard = () => {
        const newCard = { id: Date.now(), title: '', description: '', image: null, isDefault: false };
        setFormData((prevState) => ({
            ...prevState,
            cards: [...prevState.cards, newCard],
        }));
    };

    const deleteCard = (id) => {
        setFormData((prevState) => ({
            ...prevState,
            cards: prevState.cards.filter((card) => card.id !== id),
        }));
    };

    const handleCardImageChange = (id, file) => {
        const reader = new FileReader();
        reader.onload = () => {
            setFormData((prevState) => ({
                ...prevState,
                cards: prevState.cards.map((card) =>
                    card.id === id ? { ...card, image: reader.result } : card
                ),
            }));
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };

    // Post Type
    const handleBoxClick = (value) => {
        setFormData(prevState => ({
            ...prevState,
            postType: value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData(prevState => ({
                    ...prevState,
                    imagePreview: reader.result,
                    imageFile: file,
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    // Device View
    const handleDeviceSelection = (device) => {
        setActiveDevice(device);
    };

    // Form Change & Submit
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    console.log('formdata', formData)

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log({ activeTab, formData });
    };

    return (
        <div className='preview-form'>
            <div className='social-head'>
                <div>
                    <FontAwesomeIcon icon={faFacebook} size="2x" />
                    <p>Facebook</p>
                </div>
                <div className='social-preview-head'>
                    <p>Live preview</p>
                    {(formData.postType === 'Post Carousel' || formData.postType === 'Post') && (
                        <div>
                            <button
                                className={`box-responsive-icon ${activeDevice === 'desktop' ? 'active' : ''}`}
                                onClick={() => handleDeviceSelection('desktop')}
                                aria-label="Desktop view"
                            >
                                <FontAwesomeIcon icon={faDesktop} size="lg" />
                            </button>
                            <button
                                className={`box-responsive-icon ${activeDevice === 'mobile' ? 'active' : ''}`}
                                onClick={() => handleDeviceSelection('mobile')}
                                aria-label="Mobile view"
                            >
                                <FontAwesomeIcon icon={faMobileAlt} size="lg" />
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* form */}
            <form onSubmit={handleSubmit} className='form-info-preview'>
                <div className='form-data'>
                    <h4>Post</h4>
                    <div className='form-tab'>
                        <button
                            type="button"
                            onClick={() => setActiveTab('organic')}
                            className={`tab-button ${activeTab === 'organic' ? 'active' : ''}`}
                            aria-pressed={activeTab === 'organic'}
                        >
                            Organic posts
                        </button>
                        <button
                            type="button"
                            onClick={() => setActiveTab('paid')}
                            className={`tab-button ${activeTab === 'paid' ? 'active' : ''}`}
                            aria-pressed={activeTab === 'paid'}
                        >
                            Paid ads
                        </button>
                    </div>
                    <div className='form-data-inner'>
                        <h4>Content</h4>
                        <div className='post-type-wrapper'>
                            {['Post', 'Post Carousel', 'Story', 'Story Carousel'].map((type) => (
                                (type !== 'Post Carousel' || activeTab === 'paid') && (
                                    <button
                                        key={type}
                                        onClick={() => handleBoxClick(type)}
                                        className={`post-type ${formData.postType === type ? 'post-type-selected' : ''}`}
                                        aria-pressed={formData.postType === type}
                                    >
                                        <img
                                            src={
                                                type === 'Post'
                                                    ? Postimage
                                                    : type === 'Post Carousel'
                                                        ? Postcarouselimage
                                                        : type === 'Story'
                                                            ? Storyimage
                                                            : Storycarouselimage
                                            }
                                            alt={`${type} preview`}
                                        />
                                        <p>{type}</p>
                                    </button>
                                )
                            ))}
                        </div>

                        <div className='mockup-name'>
                            <label htmlFor="pageInfo">{activeTab === 'organic' ? 'Page info' : 'Advertiser info'} <span>*</span></label>
                            <div className='image-uploader'>
                                <input
                                    type="file"
                                    id="imageUpload"
                                    className="image-input"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    aria-label="Upload page logo"
                                />
                                <button 
                                    type="button"
                                    className='upload-logo-image' 
                                    onClick={() => document.getElementById('imageUpload').click()}
                                    aria-label="Upload page logo"
                                >
                                    <img src={UploadLogoIcon} alt="Upload logo" />
                                </button>
                                <input
                                    type="text"
                                    id="pageInfo"
                                    name="pageInfo"
                                    placeholder="Page name"
                                    value={formData.pageInfo}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        {formData.postType === 'Post' ? (
                            <div className='mockup-name'>
                                <label htmlFor="message">Message</label>
                                <textarea
                                    type="text"
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Your Message Here"
                                />
                            </div>
                        ) : null}

                        <div className="mockup-name">
                            {formData.cards.map((card, index) => (
                                <div key={card.id} className="card-container">
                                    <div className="mockup-name">
                                        {formData.postType === 'Post' ? (
                                            <>
                                                {activeTab === 'organic' ? (
                                                    <p>Carousel</p>
                                                ) : (
                                                    <h4>Image or video</h4>
                                                )}
                                                <p>Compelling images will encourage your target audience to engage. Recommended image size: 1,200 x 628 pixels.</p>
                                                <h4>{activeTab === 'organic' ? `Card ${index + 1}` : ''}</h4>
                                            </>
                                        ) : formData.postType === 'Story Carousel' ? (
                                            <>
                                                <p>Carousel</p>
                                                <p>Compelling images will encourage your target audience to engage. Recommended image size: 1,200 x 628 pixels.</p>
                                                <h4>{activeTab === 'organic' ? `Card ${index + 1}` : ''}</h4>
                                            </>
                                        ) : (
                                            <>
                                                <h4>Image or video</h4>
                                                <p>Compelling images will encourage your target audience to engage. Recommended image size: 1,200 x 628 pixels.</p>
                                            </>
                                        )}
                                    </div>
                                    <div
                                        className="card-input"
                                        onClick={() => document.getElementById(`imageUpload-${card.id}`).click()}
                                    >
                                        <div className="input-image-icon-mock">
                                            <FontAwesomeIcon icon={faUpload} />
                                            <p>
                                                Drag and drop your files or <button type="button" onClick={() => document.getElementById(`imageUpload-${card.id}`).click()}>click here</button> to initiate the file upload.
                                            </p>
                                        </div>
                                        {card.image && (
                                            <div className="image-preview">
                                                <img src={card.image} alt="Uploaded preview" />
                                                <div className="trash-on-image">
                                                    <FontAwesomeIcon icon={faTrash} size="2x" />
                                                </div>
                                            </div>
                                        )}
                                        <input
                                            type="file"
                                            id={`imageUpload-${card.id}`}
                                            style={{ display: 'none' }}
                                            accept="image/*"
                                            onChange={(e) => handleCardImageChange(card.id, e.target.files[0])}
                                        />
                                        {!card.isDefault && (
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    deleteCard(card.id);
                                                }}
                                                className="delete-card-button"
                                            >
                                                Delete
                                            </button>
                                        )}
                                    </div>
                                    {activeTab === 'organic' ? '' : (
                                        <>
                                            {formData.postType === 'Post' ? (
                                                <>
                                                    <div className="mockup-name">
                                                        <label htmlFor={`callToAction-${card.id}`}>Call to action</label>
                                                        <p>Encourage people to click with an explicit call to action button.</p>
                                                        <select
                                                            id={`callToAction-${card.id}`}
                                                            name="callToAction"
                                                            value={card.callToAction}
                                                            onChange={(e) => handleCardChange(card.id, 'callToAction', e.target.value)}
                                                            className="form-control"
                                                        >
                                                            <option value="Learn more">Learn more</option>
                                                            <option value="Apply now">Apply now</option>
                                                            <option value="Book now">Book now</option>
                                                            <option value="Buy tickets">Buy tickets</option>
                                                            <option value="Call now">Call now</option>
                                                            <option value="Contact us">Contact us</option>
                                                            <option value="Donate now">Donate now</option>
                                                            <option value="Get directions">Get directions</option>
                                                            <option value="Get offer">Get offer</option>
                                                            <option value="Get quote">Get quote</option>
                                                            <option value="Get showtimes">Get showtimes</option>
                                                            <option value="Install now">Install now</option>
                                                            <option value="Like page">Like page</option>
                                                            <option value="Listen now">Listen now</option>
                                                            <option value="Open link">Open link</option>
                                                            <option value="Order now">Order now</option>
                                                            <option value="Play game">Play game</option>
                                                            <option value="Request time">Request time</option>
                                                            <option value="Save">Save</option>
                                                            <option value="See menu">See menu</option>
                                                            <option value="Send message">Send message</option>
                                                            <option value="Send WhatsApp message">Send WhatsApp message</option>
                                                            <option value="Shop now">Shop now</option>
                                                            <option value="Sign up">Sign up</option>
                                                            <option value="Subscribe">Subscribe</option>
                                                            <option value="Use app">Use app</option>
                                                            <option value="View event">View event</option>
                                                            <option value="Watch more">Watch more</option>
                                                            <option value="Custom text">Custom text</option>
                                                        </select>

                                                    </div>

                                                    <div className="mockup-name">
                                                        <label htmlFor={`displayLink-${card.id}`}>Display link</label>
                                                        <input
                                                            type="text"
                                                            id={`displayLink-${card.id}`}
                                                            name="displayLink"
                                                            placeholder="Display link"
                                                            value={card.displayLink}
                                                            onChange={(e) => handleCardChange(card.id, 'displayLink', e.target.value)}

                                                        />
                                                    </div>

                                                    <div className="mockup-name">
                                                        <label htmlFor={`headline-${card.id}`}>Headline</label>
                                                        <input
                                                            type="text"
                                                            id={`headline-${card.id}`}
                                                            name="headline"
                                                            placeholder="Headline"
                                                            value={card.headline}
                                                            onChange={(e) => handleCardChange(card.id, 'headline', e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="mockup-name">
                                                        <label htmlFor={`description-${card.id}`}>Description</label>
                                                        <input
                                                            type="text"
                                                            id={`description-${card.id}`}
                                                            value={card.description}
                                                            placeholder="Enter description"
                                                            onChange={(e) => handleCardChange(card.id, 'description', e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="mockup-name">
                                                        <label htmlFor={`urlLandingPage-${card.id}`}>URL Landing Page</label>
                                                        <input
                                                            type="text"
                                                            id={`urlLandingPage-${card.id}`}
                                                            value={card.urlLandingPage}
                                                            placeholder="Enter URL"
                                                            onChange={(e) => handleCardChange(card.id, 'urlLandingPage', e.target.value)}
                                                        />
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="mockup-name">
                                                        <label htmlFor={`callToAction-${card.id}`}>Call to action</label>
                                                        <p>Encourage people to click with an explicit call to action button.</p>
                                                        <select
                                                            id={`callToAction-${card.id}`}
                                                            name="callToAction"
                                                            value={card.callToAction}
                                                            onChange={(e) => handleCardChange(card.id, 'callToAction', e.target.value)}
                                                            className="form-control"
                                                        >
                                                            <option value="Learn more">Learn more</option>
                                                            <option value="Apply now">Apply now</option>
                                                            <option value="Book now">Book now</option>
                                                            <option value="Buy tickets">Buy tickets</option>
                                                            <option value="Call now">Call now</option>
                                                            <option value="Contact us">Contact us</option>
                                                            <option value="Donate now">Donate now</option>
                                                            <option value="Get directions">Get directions</option>
                                                            <option value="Get offer">Get offer</option>
                                                            <option value="Get quote">Get quote</option>
                                                            <option value="Get showtimes">Get showtimes</option>
                                                            <option value="Install now">Install now</option>
                                                            <option value="Like page">Like page</option>
                                                            <option value="Listen now">Listen now</option>
                                                            <option value="Open link">Open link</option>
                                                            <option value="Order now">Order now</option>
                                                            <option value="Play game">Play game</option>
                                                            <option value="Request time">Request time</option>
                                                            <option value="Save">Save</option>
                                                            <option value="See menu">See menu</option>
                                                            <option value="Send message">Send message</option>
                                                            <option value="Send WhatsApp message">Send WhatsApp message</option>
                                                            <option value="Shop now">Shop now</option>
                                                            <option value="Sign up">Sign up</option>
                                                            <option value="Subscribe">Subscribe</option>
                                                            <option value="Use app">Use app</option>
                                                            <option value="View event">View event</option>
                                                            <option value="Watch more">Watch more</option>
                                                            <option value="Custom text">Custom text</option>
                                                        </select>

                                                    </div>

                                                    <div className="mockup-name">
                                                        <label htmlFor={`urlLandingPage-${card.id}`}>URL Landing Page</label>
                                                        <input
                                                            type="text"
                                                            id={`urlLandingPage-${card.id}`}
                                                            value={card.urlLandingPage}
                                                            placeholder="Enter URL"
                                                            onChange={(e) => handleCardChange(card.id, 'urlLandingPage', e.target.value)}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {/* Add New Card Button */}
                                    {(formData.postType === 'Post' || formData.postType === 'Story Carousel') && (
                                        <button onClick={addNewCard} className="add-card-button">
                                            <FontAwesomeIcon icon={faPlus} />
                                            Add New Card
                                        </button>
                                    )}
                                </div>

                            ))}
                        </div>
                    </div>
                </div>

                <div className='preview-divider'>
                    <FacebookPreview
                        activeDevice={activeDevice}
                        activeTab={activeTab}
                        formData={formData}
                    />
                </div>
            </form>
        </div >
    );
};

export default SocialMediaPostCreator;